/// <amd-module name="Feed/Legacy/Helpers/PackageFilterBarHelper" />
import { IVssPageContext } from "VSS/Platform/Context";

import { IPickListItem } from "VSSUI/PickList";
import { IFilter, IFilterItemState, IFilterState } from "VSSUI/Utilities/Filter";

import { upstreamSourceToPickListItem } from "Feed/Legacy/Helpers/UpstreamHelper";

import { PackageFilterBarConstants } from "Feed/Common/Constants/Constants";
import { FeedView, UpstreamSource, UpstreamSourceType } from "Feed/Common/Contracts/Feed";
import { WebPageConstants } from "Feed/Common/Contracts/WebPage";
import * as PackageResources from "Feed/Common/Resources";

export class PackageFilterBarHelper {
    public static readonly allItem: IPickListItem = null;

    public static readonly localItem: IPickListItem = {
        key: WebPageConstants.DirectUpstreamSourceIdForThisFeedFilter,
        name: PackageResources.FeedSources_Local
    };

    public static getFeedViewPickListItem(feedView: FeedView): IPickListItem {
        feedView = this.getFeedViewFromObject(feedView);
        const name: string = feedView.name.startsWith("@") ? feedView.name : "@" + feedView.name;
        return {
            key: feedView.id,
            name
        } as IPickListItem;
    }

    // tslint:disable-next-line:no-any
    public static getFeedViewFromObject(feedView: any): FeedView {
        if (!feedView) {
            return undefined;
        }

        const hasId = feedView.hasOwnProperty("id") || !!feedView.hasOwnProperty("key");
        const hasName = feedView.hasOwnProperty("name");

        if (hasId && hasName) {
            const name: string = feedView.name;
            const resultName: string = name.startsWith("@") ? name.substring(1) : name;
            return {
                id: feedView.id || feedView.key,
                name: resultName
            } as FeedView;
        }

        return undefined;
    }

    public static setFeedViewToFilterState(filterState: IFilterState, feedView: FeedView): IFilterState {
        if (!feedView) {
            return filterState;
        }

        const pickListItem = this.getFeedViewPickListItem(feedView);
        filterState[PackageFilterBarConstants.ViewFilterKey] = { value: [pickListItem] };
        return filterState;
    }

    public static getSourcePickListItem(pageContext: IVssPageContext, source: UpstreamSource): IPickListItem {
        if (source == null) {
            return null;
        }

        if (source.name === PackageResources.UpstreamSourceKey_Local) {
            return this.localItem;
        }

        if (
            source.upstreamSourceType === UpstreamSourceType.Public ||
            source.upstreamSourceType === UpstreamSourceType.Internal
        ) {
            return upstreamSourceToPickListItem(pageContext, source);
        }

        return null;
    }

    public static setSourceToFilterState(
        pageContext: IVssPageContext,
        filterState: IFilterState,
        source: UpstreamSource
    ): IFilterState {
        const pickListItem = PackageFilterBarHelper.getSourcePickListItem(pageContext, source);
        if (pickListItem == null) {
            return filterState;
        }

        filterState[PackageFilterBarConstants.SourceFilterKey] = { value: [pickListItem] };
        return filterState;
    }

    public static getKeywordFilterTextFromFilter(filter: IFilter): string {
        return filter.getFilterItemValue<string>(PackageFilterBarConstants.KeywordFilterKey);
    }

    public static getKeywordFilterText(filterState: IFilterState): string {
        const filterTextState: IFilterItemState = filterState[PackageFilterBarConstants.KeywordFilterKey];

        if (filterTextState) {
            return filterTextState.value as string;
        }

        return null;
    }
}
